export const CLEAR_CASH_REPORT_DATA = "cashReport/clear"

export const clearCashReportData = () => ({
    type: CLEAR_CASH_REPORT_DATA,
})

export const CASH_REPORT_AGENDA_MOUNTED = "cashReport/mounted"

export const cashReportAgendaMounted = () => ({
    type: CASH_REPORT_AGENDA_MOUNTED,
})
